import { CheckCircle, WarningCircle } from "@phosphor-icons/react";

// Chip "Completo 14/19" + grupos que faltan (Fotos · Precios · Tienda).
// Clic en un grupo abre el producto en ese paso del formulario.
export default function CompletenessBadge({ completeness, published, onFix, testid }) {
  const { filled, total, complete, groups, pct } = completeness;
  const tone = complete ? "bg-emerald-50 text-emerald-700 border-emerald-200" : pct >= 60 ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-red-50 text-[#E0000F] border-red-200";
  const title = complete
    ? "Producto 100 % completo"
    : groups.filter((g) => !g.complete).map((g) => `${g.label}: ${g.missing.map((m) => m.label).join(", ")}`).join("\n");
  return (
    <div className="mt-1 flex flex-wrap items-center gap-1" data-testid={testid}>
      <span className={`inline-flex items-center gap-1 text-[10px] font-mono-data font-semibold px-1.5 py-0.5 rounded-sm border ${tone}`} title={title} data-testid={`${testid}-score`}>
        {complete ? <CheckCircle size={10} weight="fill" /> : <WarningCircle size={10} weight="fill" />} {complete ? "Completo" : `${filled}/${total}`}
        {published && <span className="ml-1 text-emerald-700">· Publicado</span>}
      </span>
      {!complete && groups.filter((g) => !g.complete).map((g) => (
        <button type="button" key={g.id} onClick={() => onFix?.(g.step)}
          className="text-[10px] font-semibold px-1.5 py-0.5 rounded-sm bg-white border border-red-200 text-[#E0000F] hover:bg-[#E0000F] hover:text-white transition-colors"
          title={`Falta: ${g.missing.map((m) => m.label).join(", ")} · clic para completar`} data-testid={`${testid}-${g.id}`}>
          {g.short} {g.filled}/{g.total}
        </button>
      ))}
    </div>
  );
}
